/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// TODO：后续整理一下 state

const getters = {
  shareLinkDetail: (state: any) => state.share.detail,
  isMobileStyle: (state: any) => state.isMobileStyle,
  haveUpload: (state: any) => state.transmission.haveUpload,
  defaultTeamOptions: (state: any) => {
    // 企业没有设置默认团队权限时，取当前系统默认权限
    const teamOptions = state.org.defaultTeamOptions;
    if (teamOptions.defaultRoleId === undefined) {
      Object.assign(teamOptions, {
        defaultRoleId: state.user.defaultRoleId,
      });
    }
    return teamOptions;
  },
};
export default getters;
